(function ($, Drupal, drupalSettings, cookies) {
  'use strict';

  function isOverflown(element) {
    // console.log(element.scrollWidth);
    // console.log($(window).outerWidth());
    return (
      element.scrollHeight > $(window).outerHeight() ||
      element.scrollWidth > $(window).outerWidth()
    );
  }

  function sliderButtonsOverflow(container, buttons) {
    if (isOverflown(container)) {
      buttons.style.display = 'flex';
    }
    $(window).resize(function () {
      if (isOverflown(container)) {
        buttons.style.display = 'flex';
      } else {
        buttons.style.display = 'none';
      }
    });
  }

  Theme.all = function (common, options) {
    // Héritage
    this.common = common;

    // Selecteurs
    this.selectors = {
      // EXEMPLES : Data,Hover; Focus...
    };

    // Éléments
    this.elements = {
      html: $('html'),
      body: $('body'),
      window: $(window),
      menuTools: $('.btn-sticky-cta'),
      blockGallery: $('.paragraph--type--block-galery .galery--content'),
      blockSlider: $('.paragraph--type--block-slider.enabled'),
      blockFaq: $('.paragraph--type--block-faq'),
      blockSliderMedias: $('.paragraph--type--container-medias', this.context),
      blockSliderReassurance: $('.paragraph--type--container-reinssurance', this.context),
      blockSliderTestimonies: $('.paragraph--type--container-2col', this.context),
      blockSliderViewRef: $('.paragraph--type--block-view-ref', this.context),
      blockSliderCards: $('.paragraph--type--container-cards', this.context),
      blockSliderHeaderRealization: $('.paragraph--type--container-realization', this.context),
      blockSliderRealization: $('.realization-header .realization-image', this.context),
      blockSliderCardsKeyPoints: $('.paragraph--type--container-cards-key-points', this.context),
    };

    // Variables
    this.toggleMenu = undefined;
    this.rellax = undefined;
    this.fixer = undefined;
  };

  Theme.all.prototype = {
    init: function () {
      // this.initLazyLoad();
      this.initMessageToolbar();
      this.initHeader();
      this.initMenuTools();
      this.initMenuMain();
      this.initMenusHeader();
      this.initMenuLanguage();
      this.initMenuSearch();
      this.initLinksDisabled();
      this.initBtnBack();
      this.initBtnBlockFooter();
      this.initContextualLinks();
      this.initPageHome();
      this.initPageReview();
      this.initBlockGallery();
      this.initBlockSliderMediasHandler();
      //this.initBlockSliderReassuranceHandler();
      this.initBlockSliderTestimonies();
      this.initBlockViewRef('.view-display-latest-news');
      this.initBlockSliderCards();
      this.initBlockSliderHeaderRealization();
      this.initBlockSliderRealizations();
      this.initBlockSliderCardsKeyPoints();
      this.initBlockFaq();
      this.initBlockVideo();
      //this.initBlockTextMedia();
      this.initViewFilters();
      this.initLanding();
      this.initSeeMore();
      this.initForms();
    },

    load: function () {
      //console.log('load');
    },
    autoload: function (options) {
      //console.log('autoload');
    },

    // /**
    //  * Lazy load
    //  */
    // initLazyLoad: function () {
    //   var ll = new LazyLoad({
    //     threshold: 0,
    //     callback_loaded: function (element) {
    //       // si l'image fait partie d'un bloc galerie : actualisation
    //       if (element.closest(".paragraph--type--block-galery")) {
    //         var all = Drupal.Theme.load("all");
    //         all.initBlockGalery();
    //       }
    //     },
    //   });
    // },

    /**
     * Block Message toolbar
     */
    initMessageToolbar: function () {
      if (typeof cookies.get('message-toolbar') == 'undefined') {
        $('.message-toolbar-info').removeClass('is-hidden');
        $('.node > header').css('padding-top', parseInt($('.node > header').css('padding-top')) + 55 + 'px');
      } else if (drupalSettings.toolbar && cookies.get('message-toolbar') != 0) {
        $('.node > header').css('padding-top', parseInt($('.node > header').css('padding-top')) + 55 + 'px');
      }
      this.elements.body.on('click touch', '.message-toolbar-info .icon-close', function (e) {
        // $('.node > header').css('padding-top', parseInt($('.node > header').css('padding-top')) - 55 + 'px');
        $(this).closest('.message-toolbar-info').addClass('is-hidden');
        let expDateCookie = new Date();
        expDateCookie.setTime(expDateCookie.getTime() + (60 * 60 * 1000)); // 60 minutes
        cookies.set('message-toolbar', 0, {path: '/', expires: expDateCookie});
      });
    },

    /**
     * header
     */
    initHeader: function () {
      this.refreshHeader(false);
      $(window).on('scroll', function () {
        var all = Drupal.Theme.load('all');
        all.refreshHeader(false);
      });
    },

    /**
     *  Init Menu Shortcuts
     */
    initMenuTools: function () {
      let self = this;

      function refreshMenuShortcuts() {
        if ($(window).scrollTop() <= 800) {
          self.elements.menuTools.addClass('is-hidden');
        } else {
          self.elements.menuTools.removeClass('is-hidden');
        }
      }

      $(window).on('scroll', function () {
        refreshMenuShortcuts();
      });
    },

    refreshHeader: function (forceSticky) {
      if ($(window).scrollTop() <= 0) {
        $('.header-site').removeClass('is-sticky');
        if ($('.header-site').hasClass('had-bg-transparent')) {
          $('.header-site').addClass('with-bg-transparent');
          $('.header-site').removeClass('had-bg-transparent');
        }
      } else if ($(window).scrollTop() > previousScrollTop &&
        $(window).scrollTop() > $('.header-site').outerHeight() &&
        forceSticky !== true) {

        if (!$('body').hasClass('menu-main-mobile-active')) {
          $('.header-site').addClass('hide');
        }
      } else {
        let makeSticky = false;
        $('.header-site').removeClass('hide');

        if ($(window).outerWidth() >= BREAKPOINT_TABLETHOR) {
          makeSticky = true;
        } else if (!$('body').hasClass('menu-main-mobile-active')) {
          makeSticky = true;
        }
        if (makeSticky && !$('.header-site').hasClass('is-sticky')) {
          $('.header-site').addClass('is-sticky');
          if ($('.header-site').hasClass('with-bg-transparent')) {
            $('.header-site').addClass('had-bg-transparent');
            $('.header-site').removeClass('with-bg-transparent');
          }
        }
      }
      previousScrollTop = $(window).scrollTop();
    },

    /**
     * Block Menu Main
     */
    initMenuMain: function () {
      /***** Menu main desktop *****/
      $('#block-menu-main .level1--item:not(:first-of-type)').addClass('hide-push');

      // niveau 0
      $('body').on(
        'mouseover touch focus',
        '.navigation #block-menu-main .level0--link',
        function (e) {
          e.preventDefault();

          let level0Item = $(this).closest('.level0--item');

          if (!level0Item.hasClass('hover')) {
            // fermeture du menu déjà sélectionné auparavant
            let level0ItemSelected = $(this)
              .closest('.level0')
              .find('.level0--item.hover');
            if (level0ItemSelected.length) {
              let menuSelected = level0ItemSelected.find(
                '.menu-dropdown--wrapper',
              );
              menuSelected.css('min-height', '0');

              level0ItemSelected.removeClass('hover');
              $('#block-menu-main .level1--item.hover').removeClass('hover').removeClass('hide-push');
            }

            // desactivation du scroll de la page si menu enfant
            if (level0Item.hasClass('parent')) {
              //$("body").css("overflow", "hidden");
            }
            // ouverture du menu sélectionné
            level0Item.addClass('hover');
          }
        },
      );
      // niveau 1
      $('body').on(
        'mouseover touch focus',
        '.navigation #block-menu-main .level1--link',
        function (e) {
          e.preventDefault();
          let level1Item = $(this).closest('.level1--item');

          if (!level1Item.hasClass('hover')) {
            // fermeture du menu déjà sélectionné auparavant
            let level1ItemSelected = $(this)
              .closest('.level1')
              .find('.level1--item.hover');
            if (level1ItemSelected.length) {
              level1ItemSelected.removeClass('hover');
            }

            // ajustement de la hauteur du menu
            // let menuChild = level1ItemSelected.find($(".menu-dropdown-1"));
            //
            // let menuParent = level1Item
            //   .closest(".menu-dropdown-0")
            //   .find(".menu-dropdown--wrapper");
            // let minHeightMenu = 0;
            // if (menuChild.length) {
            //   let megaMenuChilds = level1Item.closest(".megamenu-childs");
            //   let marginTopMegaMenuChilds = megaMenuChilds
            //     .css("margin-top")
            //     .replace("px", "");
            //   minHeightMenu =
            //     parseInt(menuChild.outerHeight()) + parseInt(marginTopMegaMenuChilds);
            //   minHeightMenu += "px";
            //   menuParent.css("min-height", minHeightMenu);
            // }
            // menuParent.css('min-height', minHeightMenu);

            // ouverture du menu sélectionné
            level1Item.addClass('hover');

            // si le menu a plus de 2 enfants : on cache le push
            $('#block-menu-main .level1--item').addClass('hide-push');
            $(this).parent().removeClass('hide-push');

          }
        },
      );
      // fermeture du menu
      $('body').on('mouseover touch', function (e) {
        if ($(window).outerWidth() >= BREAKPOINT_TABLETHOR) {
          if (!e.target.closest('#block-menu-main')) {
            if ($('#block-menu-main .level0--item.hover').length) {
              //setTimeout(function () {
              //$('#block-menu-main .level0--item').removeClass('hover').removeClass('inactive');
              $('#block-menu-main .level0--item').removeClass('hover');
              //}, 100);
            }
            if ($('#block-menu-main .level1--item.hover').length) {
              $('#block-menu-main .level1--item').removeClass('hide-push');
              $('#block-menu-main .level1--item').removeClass('hover');
            }
            //$("body").css("overflow", "unset");
          }
        }
      });

      /***** Menu main mobile *****/
      $('.btn-menu-mobile').on('click touch', function (e) {
        e.preventDefault();

        // fermeture du menu
        if ($(this).hasClass('active')) {
          // récup. du scroll avant fermeture du menu
          let scrollPageCurrent = $('#block-frontend-content').css('margin-top').replace('px', '').replace('-', '');
          $('#block-frontend-content').css('margin-top', 0);

          $('body').removeClass('menu-main-page-mobile-active');
          $(this).removeClass('active');
          $('body').removeClass('menu-main-mobile-active');

          // destruction du menu main page mobile
          $('#menu-main-page-mobile').remove();
          // si le menu avait été chargé automatiquement : on le reconstruit
          loadMenuMainPageAuto();

          // fermeture de la recherche
          $('#block-header-search').removeClass('active');

          // réaffectation du scroll d'avant ouverture du menu
          $('html, body').stop().animate({scrollTop: scrollPageCurrent}, 0);
          //previousScrollTop = $('body').outerHeight();
          var all = Drupal.Theme.load('all');
          all.refreshHeader(true);
        }
        // ouverture du menu
        else {
          // récup. du scroll pour l'aperçu miniature de la page
          $('#block-frontend-content').css('margin-top', '-' + $(window).scrollTop() + 'px');

          $(this).addClass('active');
          $('body').addClass('menu-main-mobile-active');
          window.scrollTo(0, 0);
        }

      });

      function refreshMenuMainMobile() {
        if ($(window).outerWidth() < BREAKPOINT_TABLETHOR) {
          if ($('.main-page > .navigation-mobile').length <= 0) {
            $('.main-page').prepend('<div class="navigation-mobile"></div>');
            $('.main-page > .navigation-mobile').append($('#block-menu-main'));
            $('.main-page > .navigation-mobile').append($('#block-menu-secondary'));
            $('.main-page > .navigation-mobile').append($('#block-menu-shortcuts'));
            $('.main-page > .navigation-mobile').append($('#block-menu-about'));

          }
          if ($(window).outerWidth() > BREAKPOINT_PHABLET) {
            if ($('.header-site-top-buttons-mobile').length <= 0) {
              // (re)création des boutons dans le header top
              $('.header-site--content').prepend('<div class="header-site-top-buttons-mobile"></div>');
              $('.header-site-top-buttons-mobile').append($('#block-menu-shortcuts .icon-devis').clone());
            }
          } else {
            $('.header-site-top-buttons-mobile').remove();
          }
        } else {
          if ($('.navigation #block-menu-main').length <= 0) {
            $('.header-site--content > .header-site-top-buttons-mobile').remove();
            $('.header-site-top').prepend($('#block-menu-shortcuts'));
            $('.header-site-top').prepend($('#block-menu-about'));
            $('.navigation').prepend($('#block-menu-secondary'));
            $('.navigation').prepend($('#block-menu-main'));
            $('.main-page > .navigation-mobile').remove();
          }
        }
        $('.header-site--content').addClass('loaded');
      }

      refreshMenuMainMobile();

      $(window).resize(function () {
        refreshMenuMainMobile();
      });

      /***** Menu main page mobile *****/
      $('body').on(
        'click touch',
        '.navigation-mobile #block-menu-main .level0--item.parent .level0--link',
        function (e) {
          e.preventDefault();

          let level0Item = $(this).closest('.level0--item');
          loadMenuMainPage(level0Item, true);
        },
      );

      function loadMenuMainPage(subMenu, toOpen) {
        if (subMenu.length > 0) {
          $('#menu-main-page-mobile').remove();

          // sauvegarde du scroll
          let scrollPageCurrent = $('#block-frontend-content').css('margin-top').replace('px', '').replace('-', '');
          $('#block-frontend-content').data('prev-scroll', scrollPageCurrent);

          $('#block-frontend-content').css('margin-top', 0);

          $('<div>', {
            id: 'menu-main-page-mobile',
            class: (toOpen ? 'unfolded' : ''),
            'data-id': subMenu.data('id'),
          }).insertAfter('.header-site');
          $('#menu-main-page-mobile').append(subMenu.contents().clone());
          $('#menu-main-page-mobile .level0--link > span').text('Menu ' + $('#menu-main-page-mobile .level0--link > span').text().toLowerCase());
          if (toOpen) {
            $('body').addClass('menu-main-page-mobile-active');
          }

          // fermeture du menu main mobile
          $('body').removeClass('menu-main-mobile-active');
          $('.btn-menu-mobile').removeClass('active');
        }
      }

      function loadMenuMainPageAuto() {
        let idMenuNode = $('.node--view-mode--full').data('menu-id');
        if (idMenuNode !== undefined) {
          let subMenuNode = $('.navigation-mobile #block-menu-main .sub-menu[data-id="' + idMenuNode + '"]');
          if (subMenuNode.length > 0) {
            let menuParent = subMenuNode.closest('.level0--item');
            loadMenuMainPage(menuParent, false);
          }
        }
      }

      // fermeture du menu main page mobile
      $('body').on(
        'click touch',
        '#menu-main-page-mobile .level0--link',
        function (e) {
          e.preventDefault();

          if ($('#menu-main-page-mobile').hasClass('unfolded')) {
            $('body').removeClass('menu-main-page-mobile-active');
            // destruction du menu main page mobile
            $('#menu-main-page-mobile').remove();

            // si le menu avait été chargé automatiquement : on le reconstruit
            loadMenuMainPageAuto();

            // récup. scroll d'avant l'ouverture du menu
            let prevScroll = $('#block-frontend-content').data('prev-scroll');
            if (prevScroll !== undefined) {
              window.scrollTo(0, prevScroll);
            }
            $('#block-frontend-content').data('prev-scroll', 0);

            // affichage de la barre de menu sticky
            var all = Drupal.Theme.load('all');
            all.refreshHeader(true);
          } else {
            $('body').addClass('menu-main-page-mobile-active');
            $('#menu-main-page-mobile').addClass('unfolded');
          }
        },
      );
      $('body').on(
        'click touch',
        '#menu-main-page-mobile .level1--item.parent .level1--link',
        function (e) {
          e.preventDefault();

          $(this).closest('.level1--item.parent').toggleClass('unfolded');
        },
      );
      // si la page actuelle est rattachée au menu : chargement de celui-ci
      loadMenuMainPageAuto();

      /***** Menu shortcuts + about mobile *****/
      $('body').on(
        'click touch',
        '.navigation-mobile #block-menu-shortcuts .level0--item.parent .level0--link .arrow, ' +
        '.navigation-mobile #block-menu-about .level0--item.parent .level0--link .arrow',
        function (e) {
          e.preventDefault();

          $(this).closest('.level0--item.parent').toggleClass('unfolded');
        },
      );
    },

    /**
     * Menus header
     */
    initMenusHeader: function () {
      $('body').on(
        'mouseover touch focus',
        '#block-menu-about .level0--link, #block-menu-shortcuts .level0--link, #block-menu-secondary .level0--link',
        function (e) {
          e.preventDefault();

          let level0Item = $(this).closest('.level0--item');
          if (!level0Item.hasClass('hover')) {
            if (!e.target.closest('#block-menu-about')) {
              $('#block-menu-about .level0--item').removeClass('hover');
            }
            if (!e.target.closest('#block-menu-shortcuts')) {
              $('#block-menu-about .level0--item').removeClass('hover');
            }
            if (!e.target.closest('#block-menu-secondary')) {
              $('#block-menu-about .level0--item').removeClass('hover');
            }

            $(this)
              .closest('.level0')
              .find('.level0--item.hover')
              .removeClass('hover');
            level0Item.addClass('hover');
          }
        },
      );
      $('body').on('mouseover touch', function (e) {
        if (!e.target.closest('#block-menu-about')) {
          if ($('#block-menu-about .level0--item.hover').length) {
            setTimeout(function () {
              $('#block-menu-about .level0--item').removeClass('hover');
            }, 100);
          }
        }
        if (!e.target.closest('#block-menu-shortcuts')) {
          if ($('#block-menu-shortcuts .level0--item.hover').length) {
            setTimeout(function () {
              $('#block-menu-shortcuts .level0--item').removeClass('hover');
            }, 100);
          }
        }
        if (!e.target.closest('#block-menu-secondary')) {
          if ($('#block-menu-secondary .level0--item.hover').length) {
            setTimeout(function () {
              $('#block-menu-secondary .level0--item').removeClass('hover');
            }, 100);
          }
        }
      });
    },

    /**
     * Menu language
     */
    initMenuLanguage: function () {
      $('body').on(
        'mouseover touch focus',
        '#block-language-selector .language-link',
        function (e) {
          e.preventDefault();
          $('#block-language-selector').addClass('open');
        },
      );
      $('body').on(
        'mouseout focusout',
        '#block-language-selector',
        function (e) {
          e.preventDefault();
          $(this).removeClass('open');
        },
      );
    },

    /**
     * Menu Recherche
     */
    initMenuSearch: function () {
      $('body').on(
        'click touch',
        '#block-header-search .link-search',
        function (e) {
          e.preventDefault();
          $('#block-header-search').toggleClass('active');
          if ($('#block-header-search').hasClass('active')) {
            $('#block-header-search .form-search').focus();
          }
        },
      );
      $('body').on(
        'keyup',
        '#block-header-search .form-search',
        function (e) {
          e.preventDefault();
          //console.log(e);
          let keyCode = e.keyCode || e.which;
          if (keyCode == 27) {
            $('#block-header-search').removeClass('active');
          }
        },
      );
    },

    /**
     * Traitement des liens obfusqués
     */
    initLinksDisabled: function () {
      $('body').on(
        'click touch',
        '.link-disabled',
        function (e) {
          e.preventDefault();
          let urlEncoded = $(this).data('link');
          let urlDecoded = decodeURIComponent(window.atob(urlEncoded));
          //console.log(urlDecoded);
          if ($(this).attr('target') == '_blank' || e.ctrlKey) {
            window.open(urlDecoded);
          } else {
            document.location.href = urlDecoded;
          }
        },
      );
    },
    /**
     * Traitement des liens de retours à la page préc.
     */
    initBtnBack: function () {
      $('body').on(
        'click touch',
        '.btn-back',
        function (e) {
          e.preventDefault();
          window.history.back();
        },
      );
    },

    /**
     * Block Gallery
     */
    initBlockGallery: function () {
      let self = this;

      if (self.elements.blockGallery.length) {
        self.elements.blockGallery.each(function () {
          let galleryImages = $(this);

          galleryImages.masonry({
            // options
            //columnWidth: self.elements.blockGallery.find('.paragraph--type--block-image')[1],
            horizontalOrder: true,
            percentPosition: true,
            gutter: 0,
          });

          let showMore = galleryImages.find('.show-more');
          showMore.on('click', function (e) {
            e.preventDefault();
            // utilise data-shown et data-nbItems pour afficher les 7 prochains éléments .gallery-item ayant une class item-INDEX en enlevant la classe hidden puis actualiser les data
            let shown = showMore.data('shown');
            let next = shown + 7;
            let galleryItems = galleryImages.find('.gallery-item');

            galleryItems.each(function (index) {
              if (index >= shown && index < next) {
                $(this).removeClass('hidden');
              }
            });

            showMore.data('shown', next);
            if (next >= galleryItems.length) {
              showMore.addClass('hidden');
            }

            // On relance le masonry
            galleryImages.masonry('layout');
          });
        });
      }
    },

    /**
     * Block Slider Medias
     */
    initBlockSliderMediasHandler: function () {
      let self = this;

      if (self.elements.blockSliderMedias.length) {
        self.elements.blockSliderMedias.find('.swiper-wrapper').each(function (i, slider) {
          slider = $(slider);

          // récup param autoplay
          let paramAutoplay = false;
          if ($(this).hasClass('autoplay-slow')) {
            paramAutoplay = {delay: 10000};
          } else if ($(this).hasClass('autoplay-fast')) {
            paramAutoplay = {delay: 3000};
          } else if ($(this).hasClass('autoplay-normal')) {
            paramAutoplay = {delay: 5000};
          }

          let numberSlider = slider.data('number-swiper');

          if (parseInt(numberSlider) > 1) {
            // init slider
            let options = {
              slidesPerView: 1.1,
              autoplay: paramAutoplay,
              autoHeight: true,
              pagination: {
                enabled: true,
              },
              navigation: {
                enabled: true,
              },
              breakpoints: {
                1024: {
                  slidesPerView: 1,
                  pagination: {
                    enabled: false,
                  },
                },
              },
            };

            self.common.initDefaultSwiper(slider, options);
          }
        });
      }
    },

    /**
     * Block Slider Reassurance
     */
    initBlockSliderReassuranceHandler: function () {
      let self = this;

      if (self.elements.blockSliderReassurance.length) {
        self.elements.blockSliderReassurance.find('.swiper-wrapper').each(function (i, slider) {
          slider = $(slider);

          // init slider
          let options = {
            slidesPerView: 1,
            autoplay: false,
            autoHeight: true,
            spaceBetween: 0,
            pagination: {
              enabled: true,
            },
            navigation: {
              enabled: false,
            },
            breakpoints: {
              768: {
                slidesPerView: 2,
                spaceBetween: 0,
                pagination: {
                  enabled: false,
                },
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 0,
                pagination: {
                  enabled: false,
                },
              },
            },
          };

          self.common.initDefaultSwiper(slider, options);
        });
      }
    },

    /**
     * Block Slider Testimonies
     */
    initBlockSliderTestimonies: function () {
      let self = this;

      if (self.elements.blockSliderTestimonies.length) {
        self.elements.blockSliderTestimonies.find('.block-testimony--block-testimony').each(function (i, slider) {
          slider = $(slider);

          if ($(window).outerWidth() < BREAKPOINT_TABLET) {
            // init slider
            let options = {
              slidesPerView: 1.1,
              autoplay: false,
              autoHeight: true,
              pagination: {
                enabled: true,
              },
              navigation: {
                enabled: false,
              },
              breakpoints: {
                768: {
                  slidesPerView: 2,
                  spaceBetween: 0,
                  pagination: {
                    enabled: false,
                  },
                },
              },
            };

            self.common.initDefaultSwiper(slider, options);
          }
        });
      }
    },

    /**
     * Block Slider View Ref
     */
    initBlockViewRef: function (nameView) {
      let self = this;

      if (self.elements.blockSliderViewRef.length) {
        self.elements.blockSliderViewRef.find(nameView + ' .view-list--wrapper').each(function (i, slider) {
          slider = $(slider);

          // init slider
          let options = {
            slidesPerView: 1.1,
            autoplay: false,
            autoHeight: false,
            autoWidth: true,
            pagination: {
              enabled: true,
            },
            navigation: {
              enabled: false,
            },
            breakpoints: {
              768: {
                slidesPerView: 2,
                autoWidth: true,
                spaceBetween: 24,
                preventInteractionOnTransition: true,
                pagination: {
                  enabled: true,
                },
              },
              1024: {
                slidesPerView: 2,
                autoWidth: true,
                spaceBetween: 24,
                preventInteractionOnTransition: true,
                pagination: {
                  enabled: true,
                },
              },
              1350: {
                slidesPerView: 3,
                autoWidth: false,
                spaceBetween: 0,
                preventInteractionOnTransition: false,
                pagination: {
                  enabled: false,
                },
              },
            },
          };

          self.common.initDefaultSwiper(slider, options);
        });
      }
    },

    /**
     * Block Slider Cards
     */
    initBlockSliderCards: function () {
      let self = this;

      if (self.elements.blockSliderCards.length) {
        self.elements.blockSliderCards.find('.paragraph--row').each(function (i, slider) {
          slider = $(slider);

          // init slider
          let options = {
            slidesPerView: 1.1,
            autoplay: false,
            autoHeight: false,
            autoWidth: true,
            pagination: {
              enabled: true,
            },
            breakpoints: {
              768: {
                slidesPerView: 2,
                autoWidth: true,
                navigation: {
                  enabled: false,
                },
                pagination: {
                  enabled: true,
                },
              },
              1024: {
                slidesPerView: 2,
                navigation: {
                  enabled: true,
                },
                pagination: {
                  enabled: false,
                },
              },
              1350: {
                slidesPerView: 3,
                navigation: {
                  enabled: true,
                },
                pagination: {
                  enabled: false,
                },
              },
              1920: {
                slidesPerView: 4,
                autoWidth: true,
                navigation: {
                  enabled: true,
                },
                pagination: {
                  enabled: false,
                },
              },
            },
          };

          self.common.initDefaultSwiper(slider, options);
        });
      }
    },

    /**
     * Block Slider Header Realizations
     */
    initBlockSliderHeaderRealization: function () {
      let self = this;

      if (self.elements.blockSliderHeaderRealization.length) {
        self.elements.blockSliderHeaderRealization.find('.paragraph--row').each(function (i, slider) {
          slider = $(slider);

          // init slider
          let options = {
            slidesPerView: 1.1,
            autoplay: false,
            autoHeight: false,
            autoWidth: true,
            pagination: {
              enabled: true,
            },
            breakpoints: {
              768: {
                slidesPerView: 1,
                navigation: {
                  enabled: true,
                },
                pagination: {
                  enabled: false,
                },
              },
            },
          };

          self.common.initDefaultSwiper(slider, options);
          slider.removeClass('slider--primary-swiper');
        });
      }
    }, /**
     * Block Slider Realizations
     */
    initBlockSliderRealizations: function () {
      let self = this;

      if (self.elements.blockSliderRealization.length) {
        self.elements.blockSliderRealization.find('.field_banners').each(function (i, slider) {
          slider = $(slider);

          // init slider
          let options = {
            slidesPerView: 1,
            autoplay: false,
            autoHeight: false,
            autoWidth: true,
            navigation: {
              enabled: true,
            },
            pagination: {
              enabled: false,
            },
          };

          self.common.initDefaultSwiper(slider, options);
          //slider.removeClass('slider--primary-swiper');
        });
      }
    },

    /**
     * Block Slider Cards Key Points
     */
    initBlockSliderCardsKeyPoints: function () {
      let self = this;

      if (self.elements.blockSliderCardsKeyPoints.length) {
        self.elements.blockSliderCardsKeyPoints.find('.paragraph--row').each(function (i, slider) {
          slider = $(slider);

          // init slider
          let options = {
            slidesPerView: 1.1,
            autoplay: false,
            autoHeight: false,
            autoWidth: true,
            pagination: {
              enabled: true,
            },
            breakpoints: {
              768: {
                slidesPerView: 2,
                autoWidth: true,
                navigation: {
                  enabled: false,
                },
                pagination: {
                  enabled: true,
                },
              },
              1024: {
                slidesPerView: 2,
                navigation: {
                  enabled: true,
                },
                pagination: {
                  enabled: false,
                },
              },
              1350: {
                slidesPerView: 4,
                autoWidth: true,
                navigation: {
                  enabled: true,
                },
                pagination: {
                  enabled: false,
                },
              },
            },
          };

          self.common.initDefaultSwiper(slider, options);
        });
      }
    },

    /**
     * Block Text media
     * Move button mobile
     */
    initBlockTextMedia: function () {
      const $paragraph = $('.paragraph--type--container-2col-text');
      if ($paragraph.length) {

        $paragraph.each(function (index) {
          const $buttonGroup = $(this).find('.btn-group');
          const $colImage = $(this).find('.col-image');
          const $colText = $(this).find('.col-text');
          const $colTextWrapper = $(this).find('.col-text--wrapper');
          const $colHeader = $(this).find('.paragraph--type--item-container-header');

          $(window).resize(function () {
            handleResize($colImage, $buttonGroup, $colTextWrapper, $colHeader, $colText);
          });
          handleResize($colImage, $buttonGroup, $colTextWrapper, $colHeader, $colText);
        });
      }

      function handleResize(colImage, buttonGroup, colTextWrapper, colHeader, colText) {
        if ($(window).outerWidth() < BREAKPOINT_TABLET) {
          if (colHeader.length) {
            colImage.insertAfter(colHeader);
          } else {
            colTextWrapper.prepend(colImage);
          }
        } else if ($(window).outerWidth() > BREAKPOINT_TABLET) {
          colImage.insertAfter(colText);
        }
      }
    },

    initViewFilters: function (e) {
      if ($('.node-type-list-of-realizations')[0] && location.pathname == '/prix' && location.search === '') {
        if (drupalSettings.path.currentLanguage == 'fr') {
          $('#edit-secondary #edit-field-project-surface-target-id-collapsible').before('<h2 class="title5" style="margin: 0 25px 25px 25px;">Selectionnez un projet pour afficher plus de filtres</h2>');
        }
      }
      if ($('#edit-secondary')[0] && $(window).outerWidth() > 1024) {
        $('summary[aria-controls="edit-secondary"]').on(
          'click touch',
          function (e) {
            e.preventDefault();
          });

        let checkedBoxes = $('#edit-secondary').find('input:checked');
        if (checkedBoxes.length > 0) {
          $('#edit-secondary').children().first().append('<span class="number">' + checkedBoxes.length + '</span>');
        }
        $('<div class="filters-selected"></div>').insertAfter('#edit-secondary > summary');
        checkedBoxes.each(function (index) {
          // let paramUrl = $(this).closest('.form-select').attr('name');
          // let urlCurrent = document.location.href;
          // let regExpParamUrl = new RegExp("[?&]" + paramUrl + "=([^&]+).*$");

          // Pour vider un critère il faut le faire apparaitre dans l'url avec une valeur vide
          // var urlFilter = '?' + paramUrl + '=';

          // cas particulier : si le param existe, cela veut dire que l'on se trouve sur aucune page liste correspondante aux critères séectionnés
          // dans ce cas pour vider un critère il ne faut pas le faire apparaitre dans l'url
          // if (urlCurrent.match(regExpParamUrl) !== null) {
          //   urlFilter = removeParamFromCurrentUrl(paramUrl);
          // }

          //$('.filters-selected ul').append($(this).parent().clone());
          let button = '<span data-click="' + $(this).next().attr('for') + '" class="bef-link">' + $(this).next().text() + '</span>';

          $('.filters-selected').append(button);
          // $(this).on('click touch', function (e) {
          //   return false;
          // });
        });
      } else if ($('#edit-secondary')[0] && $(window).outerWidth() < 1024) {
        $('#edit-secondary > summary').click();

        let checkedBoxes = $('#edit-secondary').find('input:checked');
        if (checkedBoxes.length > 0) {
          $('#edit-secondary').children().first().append('<span class="number">' + checkedBoxes.length + '</span>');
        }
      }
      if ($('#edit-secondary')[0]) {

        setTimeout(function () {
          $('.views-element-container').css('min-height', $('#edit-secondary').outerHeight() + 60 + 'px');
        }, 100);

        $('#edit-secondary summary').on(
          'click touch',
          function (e) {
            setTimeout(function () {
              $('.views-element-container').css('min-height', $('#edit-secondary').outerHeight() + 60 + 'px');
            }, 10);
          });

        $('.bef-link').on('click touch', function (e) {
          let data = $(this).attr('data-click');
          $('#' + data).click();
        });
      }

      if ($('.node--type--list-of-realizations .btn-list-realizations')[0]) {
        $('#edit-secondary').append($('.node--type--list-of-realizations .btn-list-realizations'));
        $('.node--type--list-of-realizations .btn-list-realizations').addClass('active');
      }
    },

    initForms: function () {

      //desactivation du +33
      Drupal.webform = Drupal.webform || {};
      Drupal.webform.intlTelInput = Drupal.webform.intlTelInput || {};
      Drupal.webform.intlTelInput.options = {nationalMode: true};

      if ($('.webform-submission-form')[0]) {

        //ajoute un * a chaque placeholder sur les inputs ayant comme classe class="form-text required"
        $('.webform-submission-form .form-text.required, .webform-submission-form .form-email, .webform-submission-form .form-tel').each(function () {
          $(this).attr('placeholder', $(this).attr('placeholder') + '*');
        });

        //ajoute un * sur la première option du select form-select required
        $('.webform-submission-form .form-select.required option:first-child').each(function () {
          $(this).text($(this).text() + '*');
        });

        /* window.addEventListener('load', function () {
          if ($('.webform-submission-form .iti__selected-flag')[0]) {
            //Reprends l'indice téléphonique de iti__selected-flag du titre exemple title="France: +33" et insère dans id="edit-phone"
              var title = $('.webform-submission-form .iti__selected-flag').attr('title');
              var phone = title.split(":");
              $('#edit-phone').val(phone[1].replace(' ', ''));
          }
        });*/

        if ($('.webform-submission-landing-page-form')[0]) {

          var element = document.getElementById('edit-rgpd--description');

          if (element.offsetHeight < element.scrollHeight ||
            element.offsetWidth < element.scrollWidth) {
            // your element has overflow and truncated
            // show read more / read less button
            $('.form-item-rgpd .description').append('<div class="read-more">En savoir plus</div>');
          } else {
            // your element doesn't overflow (not truncated)
          }

          $('.read-more').on('click', function () {
            $(this).hide();
            $('#edit-rgpd--description').css('display', 'block');
          });

        }

      }
    },

    initSeeMore: function () {
      $('.see-more').on('click', function (e) {
        e.preventDefault();
        $(this).parent().removeClass('cut');
        $(this).hide();
      });
    },

    initLanding: function (e) {

      $('#call-to-action-landing-page').on('click', function (e) {
        $('.landing-header--form').addClass('open');
        $('html').addClass('open-form-landing');
      });

      $('#close-to-action-landing-page').on('click', function (e) {
        $('.landing-header--form').removeClass('open');
        $('html').removeClass('open-form-landing');
      });
    },

    /**
     * Block FAQ
     */
    initBlockFaq: function () {
      let self = this;
      if (self.elements.blockFaq.length) {
        self.elements.blockFaq.each(function (i, faq) {
          if ($(this).hasClass('faq-tabs-active')) {
            $(this).first().find('.field_question').first().addClass('active');
          }
        });
      }

      $('body').on('click touch', '.paragraph--type--block-faq .field_question', function (e) {
          e.preventDefault();
          $(this).addClass('selected');
          $(this).closest('.paragraph--type--block-faq').find('.field_question:not(.selected)').removeClass('active');
          $(this).removeClass('selected').toggleClass('active');
        },
      );
    },

    /**
     * Block video
     */
    initBlockVideo: function () {
      $('body').on('click touch',
        '.paragraph--type--block-video-embed .block-video-embed--link.open-here',
        function (e) {
          e.preventDefault();
          $(this).closest('.paragraph--type--block-video-embed').addClass('play');
        },
      );
    },

    initBtnBlockFooter: function () {
      $('.item-footer-wrapper .btn').on('click', function (e) {
        e.preventDefault();
        window.location.href = $(this).parent().find('.form-select').val();
      });
    },

    /**
     * Contextual links
     */
    initContextualLinks: function () {
      // items
      var strContextualLinks = '';
      $('.paragraph-root').each(function () {
        if ($(this).attr('id') && $(this).attr('data-label')) {
          strContextualLinks +=
            '<li><a href="#' +
            $(this).attr('id') +
            '" id="contextual-link--' +
            $(this).attr('id') +
            '">' +
            $(this).attr('data-label') +
            '</a></li>';
        }
      });
      if (strContextualLinks != '') {
        $('.field_reference').prepend(
          '<div class="contextual-menu"><div class="contextual-menu--wrapper"><ul>' +
          strContextualLinks +
          '</ul></div></div>',
        );

        //$('.contextual-menu').attr('data-init-offset-top', $('.contextual-menu').offset().top);
        //$('.contextual-menu').attr('data-init-height', $('.contextual-menu--wrapper').outerHeight());

        $('.contextual-menu .contextual-menu--wrapper').on(
          'click touch',
          function (e) {
            e.preventDefault();

            if ($(window).outerWidth() < BREAKPOINT_TABLET) {
              $(this).closest('.contextual-menu').toggleClass('collapsed');
            }
          },
        );
        $('.contextual-menu .contextual-menu--wrapper a').on(
          'click touch',
          function (e) {
            e.preventDefault();

            if (!$(this).closest('li').hasClass('active')) {
              var target = $(this).attr('href');
              //var topAnchor = $(target).offset().top - parseInt($('.header-site').outerHeight()) - parseInt($('.contextual-menu').attr('data-init-height'));
              //var topAnchor = $(target).offset().top - parseInt($('.header-site--content').outerHeight()) - parseInt($('.contextual-menu--wrapper').outerHeight());
              var topAnchor =
                $(target).offset().top -
                parseInt($('.contextual-menu--wrapper').outerHeight());

              $('html, body').stop().animate({scrollTop: topAnchor}, 400);
            }
          },
        );

        // refresh
        this.refreshContextualLinks();

        $(window).on('scroll', function () {
          var all = Drupal.Theme.load('all');
          all.refreshContextualLinks();
        });
      }
    },

    /**
     * refreshContextualLinks
     */
    refreshContextualLinks: function () {
      var all = Drupal.Theme.load('all');
      //var menuContextualTop = $('.contextual-menu').offset().top; //$('.contextual-menu').attr('data-init-offset-top');
      //var menuContextualHeight = $('.contextual-menu--wrapper').outerHeight(); //$('.contextual-menu').attr('data-init-height');

      // items
      /*console.log($(window).scrollTop() + '+' + $('.header-site').outerHeight());
      console.log($('.contextual-menu').offset().top);
      console.log(($(window).scrollTop() + $('.header-site').outerHeight()) +'>='+ menuContextualTop);*/

      //if (($(window).scrollTop() + $('.header-site--content').outerHeight()) >= menuContextualTop) {
      /*if ($(window).scrollTop() >= menuContextualTop) {
        $('.contextual-menu').css('height', menuContextualHeight);
        //$('.contextual-menu--wrapper').css('top', $('.header-site--content').outerHeight());
        $('.contextual-menu--wrapper').css('top', '0');
        $('body').addClass('contextual-menu-sticky');
      }
      else {
        $('.contextual-menu').css('height', 'auto');
        $('.contextual-menu--wrapper').css('top', 'auto');
        $('body').removeClass('contextual-menu-sticky');
      }*/

      //var deltaTop = parseInt($('.header-site--content').outerHeight()) + parseInt($('.contextual-menu').attr('data-init-height'));
      //var deltaTop = parseInt($('.header-site--content').outerHeight()) + parseInt($('.contextual-menu--wrapper').outerHeight());
      var deltaTop = parseInt($('.contextual-menu--wrapper').outerHeight());
      var activeLink = '';
      var links = $('.contextual-menu .contextual-menu--wrapper a')
        .get()
        .reverse();
      $(links).each(function () {
        var idLink = '#' + $(this).attr('id');
        var paragRoot = $(idLink.replace('contextual-link--', '')).closest(
          '.paragraph-root',
        );

        if (all.isScrolledIntoView(paragRoot, deltaTop)) {
          activeLink = idLink;
        }
      });

      if (activeLink != '') {
        $('.contextual-menu .contextual-menu--wrapper li.active').removeClass(
          'active',
        );
        $(activeLink).closest('li').addClass('active');
      }
    },

    /**
     * isScrolledIntoView
     */
    isScrolledIntoView: function (elem, deltaTop) {
      var win = $(window);
      var viewport = {
        top: win.scrollTop() + deltaTop,
        left: win.scrollLeft(),
      };
      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height() - deltaTop;

      var bounds = elem.offset();
      bounds.right = bounds.left + elem.outerWidth();
      bounds.bottom = bounds.top + elem.outerHeight();

      //var deltaTop = parseInt($('.header-site--content').outerHeight()) + parseInt($('.contextual-menu').attr('data-init-height'));
      //var deltaTop = parseInt($('.header-site--content').outerHeight()) + parseInt($('.contextual-menu--wrapper').outerHeight());
      var deltaTop = parseInt($('.contextual-menu--wrapper').outerHeight());

      /*console.log(elem.prop('id'));
      console.log('top:' + viewport.top +'>'+ bounds.bottom);
      console.log('bottom:' + viewport.bottom +'<'+ bounds.top);*/

      return !(
        viewport.right < bounds.left ||
        viewport.left > bounds.right ||
        viewport.bottom < bounds.top + win.height() / 4 ||
        viewport.top + deltaTop > bounds.bottom
      );
    },

    /**
     * initPageHome
     */
    initPageHome: function () {
      if ($('.node--type--home .field_banners .banner').length > 1) {
        setInterval(function () {
          $('.home-header .field_banners .banner.active').removeClass('active');
          let bannerIsActive = $('.home-header .field_banners .banner.next').removeClass('next').addClass('active');

          if (bannerIsActive.next().length > 0) {
            bannerIsActive.next().addClass('next');
          } else {
            $('.home-header .field_banners .banner').first().addClass('next');
          }
        }, 7000);
      }
    },

    /**
     * initPageReview
     */
    initPageReview: function () {
      if ($('.notation-reviews').length > 0) {
        $('body').on(
          'click touch',
          '.notation-opinion-response .title',
          function (e) {
            e.preventDefault();
            $(this).closest('.notation-opinion-response').toggleClass('unfolded');
          },
        );
      }
    },
  };
})(jQuery, Drupal, drupalSettings, window.Cookies);
